import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-0" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "mt-0" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }

import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import Card from 'primevue/card';
import PayoutSummary from '@/components/PayoutSummary.vue';
import PayoutService from '@/services/PayoutService';
import DoctorService from '@/services/DoctorService';
import { PayoutSummaryResponse } from '@/interfaces/PayoutSummary';
import { Doctor } from '@/interfaces/Doctor';
import { DateUtils } from '@/utils/DateUtils';


export default /*#__PURE__*/_defineComponent({
  __name: 'PayoutSummaryView',
  setup(__props) {

const route = useRoute();
const payoutId = route.params.id as string;
const refId = route.query.doctorId as string | undefined;

const payout = ref<PayoutSummaryResponse | null>(null);
const doctor = ref<Doctor | null>(null);
const loading = ref(true);

onMounted(async () => {
  try {
    if (refId) {
      payout.value = await PayoutService.fetchPayoutSummaryByDoctorId(refId);
    } else {
      payout.value = await PayoutService.fetchPayoutSummary(payoutId);
    }

    if (payout.value?.doctorId) {
      doctor.value = await DoctorService.fetchDoctor(payout.value.doctorId);
    }
  } catch (err) {
    console.error('Failed to load payout summary', err);
  } finally {
    loading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Card), null, {
    title: _withCtx(() => [
      _createElementVNode("h2", _hoisted_1, [
        _createTextVNode(" Borderou consultatii "),
        (doctor.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, "- " + _toDisplayString(doctor.value.firstName) + " " + _toDisplayString(doctor.value.lastName), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("h5", _hoisted_3, [
        (payout.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, " Perioada: " + _toDisplayString(_unref(DateUtils).formatWithTime(payout.value.startDate)) + " – " + _toDisplayString(_unref(DateUtils).formatWithTime(payout.value.endDate)), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_5, "Nedecontat"))
      ])
    ]),
    content: _withCtx(() => [
      _createVNode(PayoutSummary, {
        consultations: payout.value?.consultations || []
      }, null, 8, ["consultations"])
    ]),
    _: 1
  }))
}
}

})